/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddBorrowerToCartSecureCommand,
  CreateBorrowerCartItemCommand,
  ErrorResponse,
  GetBorrowerShoppingCartResponse,
  OperationResponse,
  ValidatePanierEmprunteurResponse,
} from '../models/index';
import {
    AddBorrowerToCartSecureCommandFromJSON,
    AddBorrowerToCartSecureCommandToJSON,
    CreateBorrowerCartItemCommandFromJSON,
    CreateBorrowerCartItemCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetBorrowerShoppingCartResponseFromJSON,
    GetBorrowerShoppingCartResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    ValidatePanierEmprunteurResponseFromJSON,
    ValidatePanierEmprunteurResponseToJSON,
} from '../models/index';

export interface AddBorrowerToCartSecureRequest {
    addBorrowerToCartSecureCommand: AddBorrowerToCartSecureCommand;
}

export interface CreateBorrowerCartItemRequest {
    createBorrowerCartItemCommand: CreateBorrowerCartItemCommand;
}

export interface FetchBorrowerShoppingCartRequest {
    borrowerProjectId: string;
}

export interface RemoveBorrowerCartItemRequest {
    borrowerProjectId: string;
    hash: string;
}

export interface ValidatePanierEmprunteurRequest {
    borrowerProjectId: string;
}

/**
 * 
 */
export class ShoppingCartApi extends runtime.BaseAPI {

    /**
     * Add borrower product to cart securely (pricing rebuilt server-side)
     */
    async addBorrowerToCartSecureRaw(requestParameters: AddBorrowerToCartSecureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerShoppingCartResponse>> {
        if (requestParameters['addBorrowerToCartSecureCommand'] == null) {
            throw new runtime.RequiredError(
                'addBorrowerToCartSecureCommand',
                'Required parameter "addBorrowerToCartSecureCommand" was null or undefined when calling addBorrowerToCartSecure().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/paniers/emprunteurs/secure`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddBorrowerToCartSecureCommandToJSON(requestParameters['addBorrowerToCartSecureCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerShoppingCartResponseFromJSON(jsonValue));
    }

    /**
     * Add borrower product to cart securely (pricing rebuilt server-side)
     */
    async addBorrowerToCartSecure(requestParameters: AddBorrowerToCartSecureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerShoppingCartResponse> {
        const response = await this.addBorrowerToCartSecureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add contract to shopping cart
     */
    async createBorrowerCartItemRaw(requestParameters: CreateBorrowerCartItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerShoppingCartResponse>> {
        if (requestParameters['createBorrowerCartItemCommand'] == null) {
            throw new runtime.RequiredError(
                'createBorrowerCartItemCommand',
                'Required parameter "createBorrowerCartItemCommand" was null or undefined when calling createBorrowerCartItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/paniers/emprunteurs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBorrowerCartItemCommandToJSON(requestParameters['createBorrowerCartItemCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerShoppingCartResponseFromJSON(jsonValue));
    }

    /**
     * Add contract to shopping cart
     */
    async createBorrowerCartItem(requestParameters: CreateBorrowerCartItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerShoppingCartResponse> {
        const response = await this.createBorrowerCartItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Init borrower pricing interface
     */
    async fetchBorrowerShoppingCartRaw(requestParameters: FetchBorrowerShoppingCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerShoppingCartResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling fetchBorrowerShoppingCart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/paniers/emprunteurs/projets-emprunts/{borrowerProjectId}`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerShoppingCartResponseFromJSON(jsonValue));
    }

    /**
     * Init borrower pricing interface
     */
    async fetchBorrowerShoppingCart(requestParameters: FetchBorrowerShoppingCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerShoppingCartResponse> {
        const response = await this.fetchBorrowerShoppingCartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete shopping cart item by Hash
     */
    async removeBorrowerCartItemRaw(requestParameters: RemoveBorrowerCartItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling removeBorrowerCartItem().'
            );
        }

        if (requestParameters['hash'] == null) {
            throw new runtime.RequiredError(
                'hash',
                'Required parameter "hash" was null or undefined when calling removeBorrowerCartItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/paniers/emprunteurs/projets-emprunts/{borrowerProjectId}/hashs/{hash}`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))).replace(`{${"hash"}}`, encodeURIComponent(String(requestParameters['hash']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete shopping cart item by Hash
     */
    async removeBorrowerCartItem(requestParameters: RemoveBorrowerCartItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.removeBorrowerCartItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Doit être appelé avant d\'accéder à la contractualisation. Retourne les identifiants nécessaires pour la redirection.
     * Valide le panier emprunteur et crée les devis pour chaque emprunteur
     */
    async validatePanierEmprunteurRaw(requestParameters: ValidatePanierEmprunteurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidatePanierEmprunteurResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling validatePanierEmprunteur().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/paniers/emprunteurs/projets-emprunts/{borrowerProjectId}/validate`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidatePanierEmprunteurResponseFromJSON(jsonValue));
    }

    /**
     * Doit être appelé avant d\'accéder à la contractualisation. Retourne les identifiants nécessaires pour la redirection.
     * Valide le panier emprunteur et crée les devis pour chaque emprunteur
     */
    async validatePanierEmprunteur(requestParameters: ValidatePanierEmprunteurRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidatePanierEmprunteurResponse> {
        const response = await this.validatePanierEmprunteurRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
